import request from '@aned/request';
import { removeApiPrefix } from '@/utils/requestPath';

// Torna share: Br2jl3XG
// 区域执行时效配置 - 分页查询
export const areaExecutionPageApi = '/api/cityToCity/dispatchStandardRegion/selectPage';
// 区域执行时效配置 - 批量更新
export const areaExecutionBatchUpdateDistanceApi =
  '/api/cityToCity/dispatchStandardRegion/batchUpdateDistance';
// 区域执行时效配置 - 单条更新
export const areaExecutionUpdateDistanceApi =
  '/api/cityToCity/dispatchStandardRegion/updateDistance';
// 区域执行时效配置 - 导入
export const areaExecutionImportApi = '/api/cityToCity/dispatchStandardRegion/importData';
// 区域执行时效配置 - 导出
export const areaExecutionExportApi = '/api/cityToCity/dispatchStandardRegion/export';
// 区域执行时效配置 - 获取区域类型枚举
export const areaExecutionAreaTypeEnumApi =
  '/api/cityToCity/dispatchStandardRegion/getAreaTypeEnum';
// 区域执行时效配置 - 查询分拨收派件区域类型配置
export const areaExecutionSelectDistanceConfigListApi =
  '/api/cityToCity/dispatchStandardRegion/selectDistanceConfigList';
// 区域执行时效配置 - 导出分拨收派件区域类型配置
export const areaExecutionExportDistanceConfigApi =
  '/api/cityToCity/dispatchStandardRegion/exportDistanceConfig';
// 区域执行时效配置 - 最终生效配置保存
export const areaExecutionFinalEffectApi =
  '/api/cityToCity/dispatchStandardRegion/updateExecutionHours';

export const areaExecutionPagePath = removeApiPrefix(areaExecutionPageApi);
export const areaExecutionBatchUpdateDistancePath = removeApiPrefix(
  areaExecutionBatchUpdateDistanceApi,
);
export const areaExecutionUpdateDistanceEditPath = removeApiPrefix(areaExecutionFinalEffectApi);
export const areaExecutionUpdateDistancePath = removeApiPrefix(areaExecutionUpdateDistanceApi);
export const areaExecutionImportPath = removeApiPrefix(areaExecutionImportApi);
export const areaExecutionExportPath = removeApiPrefix(areaExecutionExportApi);
export const areaExecutionAreaTypeEnumPath = removeApiPrefix(areaExecutionAreaTypeEnumApi);
export const areaExecutionSelectDistanceConfigListPath = removeApiPrefix(
  areaExecutionSelectDistanceConfigListApi,
);
export const areaExecutionExportDistanceConfigPath = removeApiPrefix(
  areaExecutionExportDistanceConfigApi,
);

// 区域执行时效配置 - 分页查询
export async function fetchAreaExecutionPage(params) {
  return request(areaExecutionPageApi, {
    method: 'POST',
    body: params,
    reqType: 'json',
    module: 'basic',
  });
}

// 区域执行时效配置 - 导出
export async function fetchAreaExecutionExport(params) {
  return request(areaExecutionExportApi, {
    method: 'POST',
    body: params,
    reqType: 'json',
    module: 'basic',
  });
}

// 区域执行时效配置 - 获取区域类型枚举
export async function fetchAreaExecutionAreaTypeEnum() {
  return request(areaExecutionAreaTypeEnumApi, {
    method: 'GET',
    module: 'basic',
  });
}

// 区域执行时效配置 - 查询分拨收派件区域类型配置
export async function fetchAreaExecutionDistanceConfigList() {
  return request(areaExecutionSelectDistanceConfigListApi, {
    method: 'POST',
    reqType: 'json',
    module: 'basic',
  });
}

// 区域执行时效配置 - 导出分拨收派件区域类型配置
export async function fetchAreaExecutionExportDistanceConfig() {
  return request(areaExecutionExportDistanceConfigApi, {
    method: 'POST',
    reqType: 'json',
    module: 'basic',
  });
}

// 区域执行时效配置 - 批量更新
export async function fetchAreaExecutionBatchUpdateDistance(params) {
  return request(areaExecutionBatchUpdateDistanceApi, {
    method: 'POST',
    body: params,
    reqType: 'json',
    module: 'basic',
  });
}

// 区域执行时效配置 - 单条更新
export async function fetchAreaExecutionUpdateDistance(params) {
  return request(areaExecutionUpdateDistanceApi, {
    method: 'POST',
    body: params,
    reqType: 'json',
    module: 'basic',
  });
}

// 区域执行时效配置 - 导入
export async function fetchAreaExecutionImport(params) {
  return request(areaExecutionImportApi, {
    method: 'POST',
    body: params,
    reqType: 'json',
    module: 'basic',
  });
}

export const areaExecutionFinalEffectPath = removeApiPrefix(areaExecutionFinalEffectApi);

export async function fetchAreaExecutionFinalEffect(params) {
  return request(areaExecutionFinalEffectApi, {
    method: 'POST',
    body: params,
    reqType: 'json',
    module: 'basic',
  });
}
